import * as ReactRouter from "react-router";
import { MarketingLayout } from "~/app/components/landing/marketing-layout";

export default function InterpretacjePodatkoweLayout() {
  return (
    <MarketingLayout locale="pl">
      <ReactRouter.Outlet />
    </MarketingLayout>
  );
}
